import {
  Card,
  CardBody,
  CardText,
  CardHeader,
  Button,
  Popover,
  PopoverBody,
} from "reactstrap";
import { Calendar, Clock, User } from "react-feather";
import { useContext, useEffect, useMemo, useState } from "react";
import { deleteConfirmationModal } from "../../../Shared/Components/DeleteConfrimationModal";

import NoteContext from "../Context/Index";
import { MODEL_TYPE_ENUM } from "../../../Shared/Constants/enums";
import FilesList from "./FilesList";
import LinksList from "./LinksList";

export default function CardNote({ note, index }) {
  const {
    setShowModal,
    setItem,
    deleteItem,
    setReadOnly,
    setIsAdding,
    setIndex,
  } = useContext(NoteContext);

  const handleEdit = () => {
    setIndex(index);

    setReadOnly(false);
    setItem(note);
    setShowModal(true);
    setIsAdding(false);
  };

  const handleView = () => {
    setReadOnly(true);
    setItem(note);
    setIsAdding(false);
    setShowModal(true);
  };

  const handleDelete = () => {
    deleteConfirmationModal(note.id, deleteItem);
  };

  const decodeNoteData = () => {
    let parsedData = {};
    if (note != undefined && note?.data) {
      parsedData = JSON.parse(note?.data);
    }

    return parsedData;
  };

  const memoizedNoteData = useMemo(() => decodeNoteData(), [note]);

  const getInitials = (userName) => {
    const [firstName, lastName] = userName.split(" ");
    return `${firstName[0]}${lastName[0]}`;
  };
  const initials = useMemo(() => getInitials(note.user_name), [note.user_name]);
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: "2-digit", minute: "2-digit" };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };
  const [popoverLinksOpen, setPopoverLinksOpen] = useState(false);
  const [popoverFilesOpen, setPopoverFilesOpen] = useState(false);
  const [popoverImagesOpen, setPopoverImagesOpen] = useState(false);
  return (
    <Card
      className="p-2 border border-dark border-2 w-100"
      style={{ borderColor: "#d3d3d3" }}
    >
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <div className="me-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "80px",
                height: "80px",
                backgroundColor: "#ccc",
                fontSize: "32px",
                color: "#fff",
              }}
            >
              {initials}
            </div>
          </div>
          <div className="flex-grow-1">
            <CardHeader className="p-1">
              {/* popover de enlaces */}
              <Button
                className="p-1"
                id={`PopoverLinkLists${note.id}`}
                color="link"
                onClick={() => setPopoverLinksOpen(!popoverLinksOpen)}
              >
                <i className="icon-link"></i>
              </Button>
              <Popover
                trigger="legacy"
                placement="bottom"
                isOpen={popoverLinksOpen}
                target={`PopoverLinkLists${note.id}`}
                toggle={() => setPopoverLinksOpen(!popoverLinksOpen)}
                innerClassName="rounded-1 popover-no-shadow"
                className="rounded-1 popover-no-shadow"
                style={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: "none !important",
                }}
              >
                <PopoverBody className="custom-popover-body">
                  <LinksList
                    model_id={note?.id}
                    model_type={MODEL_TYPE_ENUM.NOTE}
                  ></LinksList>
                </PopoverBody>
              </Popover>
              {/* popover de archivos */}
              <Button
                className="p-1"
                id={`PopoverFilesLists${note.id}`}
                color="link"
                onClick={() => setPopoverFilesOpen(!popoverFilesOpen)}
              >
                <i className="icon-file"></i>
              </Button>
              <Popover
                trigger="legacy"
                placement="bottom"
                isOpen={popoverFilesOpen}
                target={`PopoverFilesLists${note.id}`}
                toggle={() => setPopoverFilesOpen(!popoverFilesOpen)}
                innerClassName="rounded-1 popover-no-shadow"
                className="rounded-1 popover-no-shadow"
                style={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: "none !important",
                }}
              >
                <PopoverBody className="custom-popover-body">
                  <FilesList
                    mime_type="application"
                    model_id={note?.id}
                    model_type={MODEL_TYPE_ENUM.NOTE}
                  ></FilesList>
                </PopoverBody>
              </Popover>
              {/* popover de imagenes */}
              <Button
                className="p-1"
                id={`PopoverImagesLists${note.id}`}
                color="link"
                onClick={() => setPopoverImagesOpen(!popoverImagesOpen)}
              >
                <i className="icon-image"></i>
              </Button>
              <Popover
                trigger="legacy"
                placement="bottom"
                isOpen={popoverImagesOpen}
                target={`PopoverImagesLists${note.id}`}
                toggle={() => setPopoverImagesOpen(!popoverImagesOpen)}
                innerClassName="rounded-1 popover-no-shadow"
                className="rounded-1 popover-no-shadow"
                style={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: "none !important",
                }}
              >
                <PopoverBody className="custom-popover-body">
                  <FilesList
                    mime_type="image"
                    model_id={note?.id}
                    model_type={MODEL_TYPE_ENUM.NOTE}
                  ></FilesList>
                </PopoverBody>
              </Popover>
            </CardHeader>
            <CardText className="mb-0">
              {note?.content ?? memoizedNoteData?.content}
            </CardText>
            <div
              className="d-flex justify-content-start align-items-center mt-3 text-muted"
              style={{ fontSize: "12px" }}
            >
              <div className="d-flex align-items-start me-3">
                <Calendar size={14} className="me-1" />
                <span>{formatDate(note.created_at)}</span>
              </div>
              <div className="d-flex align-items-start me-3">
                <Clock size={14} className="me-1" />
                <span>{formatTime(note.created_at)}</span>
              </div>
              <div className="d-flex align-items-start">
                <User size={14} className="me-1" />
                <span>{note.user_name}</span>
              </div>
            </div>
          </div>
          {/* Botones de acción */}

          <div className="d-flex gap-3">
            {[
              {
                icon: "icon-eye",
                text: "Ver",
                color: "#FFAB4B",
                action: handleView,
              },
              {
                icon: "icon-pencil",
                text: "Editar",
                color: "#7CC97C",
                action: handleEdit,
              },
              {
                icon: "icon-close",
                text: "Eliminar",
                color: "#F97878",
                action: handleDelete,
              },
            ].map(({ icon, text, action, color }, index) => (
              <Button
                key={index}
                color="link"
                className="d-flex flex-column align-items-center p-0"
                onClick={action}
                style={{
                  fontSize: "9px",
                  color: "#6B6B6B",
                  textDecoration: "none",
                }}
              >
                <i
                  className={icon}
                  style={{ fontSize: "20px", color: color }}
                ></i>
                <span>{text}</span>
              </Button>
            ))}
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
